import privateInstance from "../privateClient";
import { FetchTenantConfigurationQueryType } from "./types";

export const tenantApi = {
  getTenantConfiguration: async () => {
    try {
      const response = await privateInstance.get<
        FetchTenantConfigurationQueryType["Data"]
      >("/tenant-configuration/front-end-specific");

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
